import { Heading3 } from "~/components/ui/Heading";

import css from "./TitleInput.module.css";

export function TitleInput({
  label,
  name,
  value,
  onChange,
}: {
  label: string;
  name: string;
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
}) {
  return (
    <>
      <Heading3>{label}</Heading3>
      <input
        className={css.input}
        type="text"
        name={name}
        value={value}
        onChange={onChange}
      />
    </>
  );
}
